export default __webpack_public_path__ + "static/media/password-icon.734cff88.svg";